/**
 * Um valor que só muda depois de ficar parado por um tempo.
 *
 * Papel: aqui fica `useValorAtrasado`, que segura a Pesquisa de Lançamentos
 * por 300 ms sem tecla antes de ela chegar à listagem.
 *
 * Como usar: o campo continua mostrando o que a pessoa digita, porque ele lê o
 * valor de verdade; só quem pede à API lê o valor atrasado. Cada tecla
 * recomeça a espera, e um valor que volta ao anterior antes do fim não pede
 * nada de novo.
 */
import { useEffect, useState } from 'react';

/**
 * Devolve o valor depois de ele ficar parado por `espera` milissegundos.
 *
 * @param valor - O valor de agora.
 * @param espera - Quanto tempo ele precisa ficar parado.
 * @returns O último valor que ficou parado pelo tempo pedido.
 */
export function useValorAtrasado<T>(valor: T, espera: number): T {
  const [atrasado, setAtrasado] = useState(valor);
  useEffect(() => {
    const temporizador = window.setTimeout(() => setAtrasado(valor), espera);
    return () => window.clearTimeout(temporizador);
  }, [valor, espera]);
  return atrasado;
}
